const filter = document.querySelector('.js-travel-type-filter');

const nodeListToArray = (list) => Array.prototype.slice.call(list);

export default {
  /**
   * Create travel type filter
   *
   * @return {void}
   */
  initialize() {
    if (!filter) {
      return;
    }

    this.continent = filter.querySelector('.js-continent');
    this.country = filter.querySelector('.js-country');
    this.removeFilters = filter.querySelector('.js-remove-filter');
    this.countries = [];

    this.extractCountries();

    // Check the initial available countries
    this.checkAvailableCountries();
    this.checkRemoveFiltersVisibility();

    this.createEventListeners();
  },

  /**
   * Create event listeners
   *
   * @return {void}
   */
  createEventListeners() {
    if (this.continent) {
      this.continent.addEventListener('change', () => {
        this.checkAvailableCountries();
        this.checkRemoveFiltersVisibility();
      });
    }

    if (this.removeFilters) {
      this.removeFilters.addEventListener('click', () => {
        this.emptyFilters();
        this.checkAvailableCountries();
        this.checkRemoveFiltersVisibility();
      });
    }
  },

  /**
   * Check which country should be available for the selected continent
   *
   * @return {void}
   */
  checkAvailableCountries() {
    if (!this.country) {
      return;
    }

    const activeContinentId = parseInt($(this.continent).find('option:selected').data('id'), 10);

    const options = [];

    this.countries.forEach((countryObj) => {
      if (
        countryObj.parentId !== activeContinentId
        && countryObj.value !== ''
        && !Number.isNaN(activeContinentId)
      ) {
        return;
      }

      options.push(`
        <option value="${countryObj.value}">${countryObj.label}</option>
      `);
    });

    this.country.innerHTML = options.join('');
  },

  /**
   * Remove the chosen filters
   *
   * @return {void}
   */
  emptyFilters() {
    if (this.continent) {
      this.continent.value = '';
    }

    if (this.country) {
      this.country.value = '';
    }
  },

  /**
   * Check if the remove button should be visible
   *
   * @return {void}
   */
  checkRemoveFiltersVisibility() {
    let isSelected = false;

    if (this.continent && this.continent.value) {
      isSelected = true;
    }

    if (this.country && this.country.value) {
      isSelected = true;
    }

    this.removeFilters.style.display = isSelected ? 'inline-block' : 'none';
  },

  /**
   * Save all country options to an key => value object
   *
   * @return void
   */
  extractCountries() {
    if (!this.country) {
      return;
    }

    nodeListToArray(this.country.querySelectorAll('option')).forEach((option) => {
      this.countries.push({
        value: option.value,
        label: option.textContent.trim(),
        parentId: parseInt(option.getAttribute('data-parent-id'), 10),
      });
    });
  },
};
